import i18n from './../../i18n';
export const DRAWER_BODY_CSS = {
  fontSize: '12px',
  lineHeight: '20px',
  fontWeight: '400',
  color: '#121212',
};

export const STARLING_KEYS = {
  smartInterestTitle: i18n.t('module_ad_smart_interest'),
  smartInterestDescription_unchecked: `${i18n.t('module_ad_smart_interest_description')}`,
  smartInterestDescription: `${i18n.t('common_on')} ${i18n.t('module_ad_smart_interest_description')}`,
  smartInterestTooltip: i18n.t('module_ad_smart_interest_tooltip', {learn_more: `<a target=\"_blank\" style=\"color:#3451F7\" href="https://ads.tiktok.com/help/article/smart-targeting">${i18n.t('common_learn_more')}</a>`}),
};

export const EXTERNAL_URL_CONFIG = {
  text: i18n.t('common_learn_more'),
  link: 'https://ads.tiktok.com/help/article/smart-targeting',
};

export enum TRACKING_EVENTS {
  ADD = 'ttam_smart_interests_and_behaviors_add',
  REMOVE = 'ttam_smart_interests_and_behaviors_remove',
}
